import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Lesson from './pages/Lesson';
import SIPCalculator from './pages/SIPCalculator';
import Mistakes from './pages/Mistakes';
import Mistake from './pages/Mistake';
import Topics from './pages/Topics';
import Glossary from './pages/Glossary';
import GlossaryTerm from './pages/GlossaryTerm';
import Disclaimer from './pages/Disclaimer';

const ComingSoon = ({ page }) => (
  <div style={{padding:'60px',textAlign:'center',color:'#888',fontSize:'15px'}}>
    {page} — coming soon
  </div>
);

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/topic/:id" element={<Lesson />} />
        <Route path="/topics" element={<Topics />} />
        <Route path="/tools" element={<ComingSoon page="Tools" />} />
        <Route path="/tools/sip" element={<SIPCalculator />} />
        <Route path="/mistakes" element={<Mistakes />} />
        <Route path="/mistakes/:id" element={<Mistake />} />
        <Route path="/glossary" element={<Glossary />} />
        <Route path="/glossary/:slug" element={<GlossaryTerm />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
      </Routes>
    </BrowserRouter>
  );
}
